var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.url ? 'a' : 'button',{tag:"component",attrs:{"data-component":"button","href":_vm.url || false,"type":_vm.url ? false : _vm.type},on:{"click":_vm.clicked}},[_vm._t("default",[_vm._v("Button")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }